import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

import { Menu, MenuButton, MenuDivider, MenuHeader, MenuItem, MenuRadioGroup, SubMenu } from '@szhsin/react-menu';

import AddImage from './options/addImage';
import DisplayEquipment from './options/displayEquipment';
import DisplayRules from './options/displayRules';
import FontSize from './options/fontSize';
import PageOrientation from './options/pageOrientation';
import PaperSize from './options/paperSize';
import Personalize from './options/personalize';
import React from 'react';
import ReferenceSheet from './options/referenceSheet';
import { SettingsContext } from '../../context/context';
import SuccinctAbilities from './options/succinctAbilities';
import SuccinctActions from './options/succinctActions';
import TreeKiller from './options/treeKiller';
import { useContext } from 'react';

const MenuDropdown = () => {
  const { state, dispatch } = useContext(SettingsContext);

  const toggleLayout = (layoutOrientation) => {
    dispatch({ type: 'cardOrientation', payload: layoutOrientation });

    if (layoutOrientation === 'horizontal') {
      dispatch({ type: 'perPage', payload: 2})
      document.documentElement.style.setProperty(
        '--grid-cols',
        '100%'
      );
    } else {
      dispatch({ type: 'perPage', payload: 4 });
      document.documentElement.style.setProperty(
        '--grid-cols',
        '50% 50%'
      );
    }

    // const color = getComputedStyle(document.documentElement)
    //   .getPropertyValue('--grid-cols');
  }

  return (<Menu
    menuButton={<MenuButton>Options</MenuButton>}
    align="end"
    key="bottom"
    onItemClick={(e) => e.keepOpen = true}
    transition>
    <SubMenu label="Layout">
      <MenuRadioGroup value={state.cardOrientation}
          onRadioChange={e => toggleLayout(e.value)}>
          <MenuItem type="radio" value="horizontal">Horizontal</MenuItem>
          <MenuItem type="radio" value="vertical">Vertical</MenuItem>
          <MenuItem type="radio" value="playing-cards">Card</MenuItem>
      </MenuRadioGroup>
    </SubMenu>
    <MenuDivider />
    <MenuHeader>Layout Settings</MenuHeader>
    <Personalize />
    <AddImage />
    <DisplayEquipment />
    { state.cardOrientation !== 'playing-cards' ? (<DisplayRules />) : null}
    { state.cardOrientation !== 'playing-cards' ? (<SuccinctAbilities />) : null}
    { state.cardOrientation !== 'playing-cards' ? (<SuccinctActions />) : null}
    <ReferenceSheet />
    <MenuDivider />
    <MenuHeader>Paper Settings</MenuHeader>
    <PaperSize />
    <PageOrientation />
    {/* { state.cardOrientation !== 'playing-cards' ? (<TreeKiller />) : null} */}
    <FontSize />
  </Menu>);
};

export default MenuDropdown;
